import Vue from 'vue'
import Router from 'vue-router'
import Accueil from '@/views/Accueil'
import CandidatureFicheValidation from '@/views/CandidatureFicheValidation'
import ErPaiement from '@/views/ErreurPaiement'
import FormulaireCandidatureECE from '@/views/CandidatureFormulaireEce'
import FormulaireCandidatureBachelorsESCE from '@/views/CandidatureFormulaireBachelorsEsce'
import FormulaireCandidatureReboostESCE from '@/views/CandidatureFormulaireReboostEsce'
import FormulaireCandidatureFormulaireEbs from '@/views/CandidatureFormulaireEbs'
import FormulaireCandidatureFormulaireIum from '@/views/CandidatureFormulaireIum'
import FormulaireCandidatureFormulaireSupCareer from '@/views/CandidatureFormulaireSupCareer'
import FormulaireCandidatureFormulaireBachelorsMscEsce from '@/views/CandidatureFormulaireMscEsce'
import CandidatureFormulaireSupDePub from '@/views/CandidatureFormulaireSupDePub'
import CandidatureFormulaireHeip from '@/views/CandidatureFormulaireHeip'
import CandidatureFormulaireIsbe from '@/views/CandidatureFormulaireISBE'
import CandidatureFormulaireSupCareerVae from '@/views/CandidatureFormulaireSupCareerVae'
import CandidatureFormulaireSupCareerCoursSoir from '@/views/CandidatureFormulaireSupCareerCoursSoir'
import CandidatureFormulaireBachelorsInseec from '@/views/CandidatureFormulaireBachelorsInseec'
import CandidatureFormulaireMastersInseec from '@/views/CandidatureFormulaireMastersInseec'
import CandidatureFormulaireCeds from '@/views/CandidatureFormulaireCeds'
import CandidatureFormulaireInternational from '@/views/CandidatureFormulaireInternational'
import CandidatureFormulaireEbsRentreeDecalee from '@/views/CandidatureFormulaireEbsRentreeDecalee'
import CandidatureFormulaireEsceRentreeDecalee from '@/views/CandidatureFormulaireEsceRentreeDecalee'
import CandidatureFormulaireSupDeCreation from '@/views/CandidatureFormulaireSupDeCreation'
import CandidatureFormulaireInseecBba from '@/views/CandidatureFormulaireInseecBba'
import CandidatureFormulaireDba from '@/views/CandidatureFormulaireDba'
import CandidatureFormulairePhd from '@/views/CandidatureFormulairePhd'
import CandidatureFormulaireEsceInternational from '@/views/CandidatureFormulaireEsceInternational'
import CandidatureFormulaireInseecBts from '@/views/CandidatureFormulaireInseecBts'
import DashboardView from '@/views/DashboardView'
//import Maintenance from '@/views/Maintenance'

Vue.use(Router)

export default new Router({
    //mode: 'history',        // Supprimer le '#' dans l'URL
    //hash: false,
    // base: process.env.BASE_URL,

    // module.exports = { baseUrl: process.env.NODE_ENV === 'production' ? '/Extranet/' : '/' },

    routes: [
        // Route temporaire pour le mode temporaire
        //{
        //    path: '/*',
        //    name: 'maintenance',
        //    component: Maintenance
        //},
        {
            path: '/',
            name: 'Accueil',
            component: Accueil
        },
        {
            path: '/fiche',
            name: 'CandidatureFicheValidation',
            component: CandidatureFicheValidation
        },
        {
            path: '/erpai',
            name: 'ErPaiement',
            component: ErPaiement
        },
        {
            path: '/ece',
            name: 'CandidatureECE',
            component: FormulaireCandidatureECE
        },
        {
            path: '/bachelorsesce',
            name: 'CandidatureBachelorsESCE',
            component: FormulaireCandidatureBachelorsESCE
        },
        {
            path: '/reboostesce',
            name: 'FormulaireCandidatureReboostESCE',
            component: FormulaireCandidatureReboostESCE
        },
        {
            path: '/ebs',
            name: 'CandidatureFormulaireEbs',
            component: FormulaireCandidatureFormulaireEbs
        },
        {
            path: '/ium',
            name: 'CandidatureFormulaireIum',
            component: FormulaireCandidatureFormulaireIum
        },
        {
            path: '/supcareer',
            name: 'CandidatureFormulaireSupCareer',
            component: FormulaireCandidatureFormulaireSupCareer
        },

        {
            path: '/mscesce',
            name: 'CandidatureFormulaireBachelorsMscEsce',
            component: FormulaireCandidatureFormulaireBachelorsMscEsce
        },
        {
            path: '/supdepub',
            name: 'CandidatureFormulaireSupDePub',
            component: CandidatureFormulaireSupDePub
        },
        {
            path: '/heip',
            name: 'CandidatureFormulaireHeip',
            component: CandidatureFormulaireHeip
        },
        {
            path: '/isbe',
            name: 'CandidatureFormulaireIsbe',
            component: CandidatureFormulaireIsbe
        },
        {
            path: '/supcareervae',
            name: 'CandidatureFormulaireSupCareerVae',
            component: CandidatureFormulaireSupCareerVae
        },
        {
            path: '/supcareercourssoir',
            name: 'CandidatureFormulaireSupCareerCoursSoir',
            component: CandidatureFormulaireSupCareerCoursSoir
        },
        {
            path: '/bachelorsinseec',
            name: 'CandidatureFormulaireBachelorsInseec',
            component: CandidatureFormulaireBachelorsInseec
        },
        {
            path: '/mastersinseec',
            name: 'CandidatureFormulaireMastersInseec',
            component: CandidatureFormulaireMastersInseec
        },
        {
            path: '/ceds',
            name: 'CandidatureFormulaireCeds',
            component: CandidatureFormulaireCeds
        },
        {
            path: '/international',
            name: 'CandidatureFormulaireInternational',
            component: CandidatureFormulaireInternational
        },
        {
            path: '/rentreedecaleeebs',
            name: 'CandidatureFormulaireEbsRentreeDecalee',
            component: CandidatureFormulaireEbsRentreeDecalee
        },
        {
            path: '/rentreedecaleeesce',
            name: 'CandidatureFormulaireEsceRentreeDecalee',
            component: CandidatureFormulaireEsceRentreeDecalee
        },
        {
            path: '/supdecreation',
            name: 'CandidatureFormulaireSupDeCreation',
            component: CandidatureFormulaireSupDeCreation
        },
        {
            path: '/inseecbba',
            name: 'CandidatureFormulaireInseecBba',
            component: CandidatureFormulaireInseecBba
        },
        {
            path: '/dbaesce',
            name: 'CandidatureFormulaireDba',
            component: CandidatureFormulaireDba
        },
        {
            path: '/phdesce',
            name: 'CandidatureFormulairePhd',
            component: CandidatureFormulairePhd
        },
        {
            path: '/internationalesce',
            name: 'CandidatureFormulaireEsceInternational',
            component: CandidatureFormulaireEsceInternational
        },
        {
            path: '/inseecbts',
            name: 'CandidatureFormulaireInseecBts',
            component: CandidatureFormulaireInseecBts
        },
        {
            path: '/dashboard',
            name: 'DashboardView',
            component: DashboardView
        }
        
    ]
})